import { useNavigate } from "react-router-dom";
import { CustomTabs } from "../../../../components";
import { useWallet } from "../../context/WalletContext";
import styles from "./style.module.scss";

const WalletContainer = () => {
  const { walletItems, walletActiveTab } = useWallet();
  const navigate = useNavigate();

  return (
    <div className={styles.walletContainer}>
      <div className={styles.main}>
        <CustomTabs
          defaultActiveKey={walletItems[0].key}
          activeKey={walletActiveTab}
          type="card"
          size="large"
          tabPosition="left"
          items={walletItems}
          onTabClick={(e) => navigate(`/wallet/${e}/${e}?tab=${e}&radioValue=${e}`)}
        />
      </div>
    </div>
  );
};

export default WalletContainer;
